import { Phone, Mail, Clock, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY_FISCAL_DATA, LEGAL_FOOTER_TEXT } from "@/constants/fiscal";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-2xl font-bold mb-4">Pastelería Reyes</h3>
            <p className="text-primary-foreground/80 text-sm leading-relaxed">
              Más de 45 años endulzando Gran Canaria con recetas artesanales y
              tradición familiar desde {COMPANY_FISCAL_DATA.añoFundacion}.
            </p>
            <p className="text-primary-foreground/70 text-xs mt-3">
              Pastelería Reyes SL · CIF: {COMPANY_FISCAL_DATA.cif}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contacto</h4>
            <div className="space-y-3 text-sm">
              <a
                href="tel:+34928137195"
                className="flex items-center gap-2 hover:text-secondary transition-colors"
              >
                <Phone className="h-4 w-4" />
                <span>928 13 71 95</span>
              </a>
              <a
                href="mailto:pasteleriareyes@gmail.com"
                className="flex items-center gap-2 hover:text-secondary transition-colors"
              >
                <Mail className="h-4 w-4" />
                <span>pasteleriareyes@gmail.com</span>
              </a>
              {/* Instagram Social Link */}
              <div className="pt-4 border-t border-primary-foreground/20">
                <p className="text-primary-foreground/70 text-xs mb-2">Nos puedes seguir en:</p>
                <a
                  href="https://www.instagram.com/pasteleriareyeslpa/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-secondary transition-colors"
                  aria-label="Síguenos en Instagram"
                >
                  <Instagram className="h-5 w-5" />
                  <span>@pasteleriareyeslpa</span>
                </a>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Horario</h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-start gap-2">
                <Clock className="h-4 w-4 mt-0.5" />
                <div>
                  <p>Lunes a Sábado: 9:00 - 14:00 y 16:30 - 20:30</p>
                  <p>Domingos: 9:00 - 14:00</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Legal Links */}
        <div className="border-t border-primary-foreground/20 mt-8 pt-6">
          <div className="flex flex-wrap justify-center gap-4 mb-4 text-sm">
            <Link 
              to="/aviso-legal" 
              className="text-primary-foreground/80 hover:text-secondary transition-colors"
            >
              Aviso Legal
            </Link>
            <span className="text-primary-foreground/40">|</span>
            <Link 
              to="/politica-privacidad" 
              className="text-primary-foreground/80 hover:text-secondary transition-colors"
            >
              Política de Privacidad
            </Link>
          </div>
          <p className="text-center text-xs text-primary-foreground/60 leading-relaxed">
            {LEGAL_FOOTER_TEXT}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
